import a from"next/script.js";import{Fragment as g,jsx as r,jsxs as o}from"react/jsx-runtime";function e({measurementId:t}){return o(g,{children:[r(a,{src:`https://www.googletagmanager.com/gtag/js?id=${t}`,strategy:"afterInteractive"}),r(a,{strategy:"afterInteractive",children:`
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());

				gtag('config', '${t}');
			`})]})}export{e as a};
